import {Button} from '@ezcater/tapas';
import {faCircleQuestion} from '@fortawesome/pro-regular-svg-icons';
import {useRouter} from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import {twMerge} from 'tailwind-merge';

import {useContactUsModal} from '@/components/global/providers/ContactUsModalProvider';
import {useStoreNextRouter} from '@/components/global/providers/StoreNextRouter';
import AppBarIconButton from '../AppBarIconButton';
import {NAVLINK_TRACKING} from '../appBarTracking';
import useNavLinkTracking from '../hooks/useNavlinkTracking';

const Help: React.FC = () => {
  const {pathname} = useRouter();
  const {trackLink} = useNavLinkTracking();
  const {t} = useTranslation('app-bar');
  const {toggleContactUsModal} = useContactUsModal();
  const {isOnLoggedOutLandingPage} = useStoreNextRouter();

  const handleClick = () => {
    toggleContactUsModal();
    trackLink({
      path: pathname,
      title: NAVLINK_TRACKING.help.text,
      version: NAVLINK_TRACKING.help.version,
      datadogAction: NAVLINK_TRACKING.help.clicked,
    });
  };

  return (
    <>
      <div className="hidden appbar-xl:block">
        <Button
          className={twMerge(
            'whitespace-nowrap px-2.5 no-underline',
            isOnLoggedOutLandingPage && 'text-white hover:text-peppercorn-800',
          )}
          onClick={handleClick}
          variant="secondary"
        >
          {t('help.label')}
        </Button>
      </div>

      <div className="appbar-xl:hidden">
        <AppBarIconButton
          aria-label={t('help.label')}
          icon={faCircleQuestion}
          title={t('help.label')}
          onClick={handleClick}
          variant={isOnLoggedOutLandingPage ? 'contrast' : 'secondary'}
        />
      </div>
    </>
  );
};

export default Help;
